export const reworksViewMode = {
    reworkMarksModerator: 0,
    reworkModuleHeadept: 1,
};